/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {ReportWatchProvider} from '../../../../../providers';
import {Report, User} from '../../../../../model';
import {ReportService} from '../../../../../services/report.service';
import { LogService } from 'src/app/services';

@Component({
  selector: 'watch',
  templateUrl: './watch.component.html',
  styleUrls: ['./watch.component.scss']
})
export class WatchComponent implements OnInit, OnDestroy {
  @Input() hint: string;

  currentReport: Report = new Report();
  private reportSub: any;

  constructor(
    private reportWatchProvider: ReportWatchProvider,
    private reportService: ReportService,
    private logService : LogService
  ){}

  startWatching(): void {
    this.reportWatchProvider.startWatching(this.currentReport.ID)
      .subscribe(
        data => {
          if (data.success){
            let me = User.parse(data.result);

            this.currentReport.IS_WATCHING = true;
            this.currentReport.WATCHERS.push(me);
          } else {
            this.logService.error(JSON.stringify(data.result, null, 2));
          }
        }, err => {
          this.logService.error(err);
        });
  }

  stopWatching(): void {
    this.reportWatchProvider.stopWatching(this.currentReport.ID)
      .subscribe(
        data => {
          if (data.success){
            let me = User.parse(data.result);

            this.currentReport.IS_WATCHING = false;
            for(let i=0; i < this.currentReport.WATCHERS.length; i++)
              if(this.currentReport.WATCHERS[i].ID === me.ID)
                this.currentReport.WATCHERS.splice(i, 1);
          } else {
            this.logService.error(JSON.stringify(data.result, null, 2));
          }
        }, err => {
          this.logService.error(err);
        });
  }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => this.currentReport = currentReport);
  }

  ngOnDestroy(): void {
    if(this.reportSub) this.reportSub.unsubscribe();
  }

}
